import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import {
  PlusSubscriptionIsFreeTrialAvailableSelector,
  PlusSubscriptionModalSelector,
  PlusSubscriptionPlanSelectionSelector,
} from 'src/store/plusSubscription/selectors';
import { ROUTE_EVERGREEN_UPGRADE, ROUTE_PLUS_SUBSCRIPTION_UPGRADE } from 'src/routes';

export const useCheckDisabledItems = () => {
  const { IsFreeTrialExpired } = useSelector(PlusSubscriptionPlanSelectionSelector);
  const showFreeTrial = useSelector(PlusSubscriptionIsFreeTrialAvailableSelector);
  const { type: plusSubscriptionModalType } = useSelector(PlusSubscriptionModalSelector);

  const isPlusSubscriptionUpdatePage = useRouteMatch([ROUTE_EVERGREEN_UPGRADE, ROUTE_PLUS_SUBSCRIPTION_UPGRADE]);

  return (
    IsFreeTrialExpired ||
    (!showFreeTrial && !isPlusSubscriptionUpdatePage && plusSubscriptionModalType === 'planSelection')
  );
};
